import io from 'socket.io-client';

let STRAPI_ENDPOINT = process.env.VUE_APP_WS;

export const socket = io(STRAPI_ENDPOINT);
